import React from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonContent,
  IonButtons,
  IonItem,
  IonList,
  IonLabel,
  IonLoading,
  IonAvatar,
  IonImg,
  IonIcon,
} from '@ionic/react';
import { InputField } from 'components/form';
import { Field, Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import pick from 'lodash/pick';
import AppActions from 'redux/AppRedux';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import moment from 'moment';
import storage from 'utils/storage';
import { useHistory } from 'react-router';
import { close } from 'ionicons/icons';
import api_v2 from 'services/api_v2';
import schema from './schema';

function LoyaltyJoinConfirmModal({ isOpen, setLoyaltyTypeModal, venueDetail, refreshAction, locationId }) {
  const dispatch = useDispatch();
  const user = useSelector(AuthSelectors.selectUser);
  const token = useSelector(AuthSelectors.selectToken);
  const history = useHistory();

  const onCloseAction = () => {
    setLoyaltyTypeModal(null);
    refreshAction();
  }

  const handleSubmit = async (payload, actions) => {
    try {
      const api = api_v2(token);

      const data = await api.updateUser({
        birthday: !payload.birthday ? '' : moment(payload.birthday).format('YYYY-MM-DD')
      });


      dispatch(AuthActions.setUser({
        ...data,
        birthday: !payload.birthday ? '' : moment(payload.birthday).format('YYYY-MM-DD'),
        token: data.token,
      })
      );

      storage.setItem('vemospay-token', data.token);


      dispatch(AppActions.setToast('Saved successfully', 'success'));
      setLoyaltyTypeModal(null);

      if (locationId) {
        history.push(`/locations/${locationId}/tab`);
      }
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'There was problem updating user',
          'danger'
        )
      );
    }
    
    actions.setSubmitting(false);
  };

  return (
    <IonModal isOpen={isOpen} className="custom-loyalty-modal">
      <IonItem lines="none" className="mt">
        <IonButtons slot="end">
          <IonButton
            onClick={onCloseAction}
            color="tertiary"
          >
            <IonIcon color="tertiary" slot="icon-only" icon={close} />
          </IonButton>
        </IonButtons>
      </IonItem>

      <IonContent>
        <IonList>
          <IonItem lines="none">
            <div className="d-flex-content d-flex-center loyalty-venue-logo-wrapper">
              <IonAvatar slot="start" className="loyalty-venue-logo-size">
                <IonImg src={venueDetail?.logo} />
              </IonAvatar>
            </div>
          </IonItem>

          <IonItem lines="none" className="mt mb-3x">
            <div className="d-flex-content">
              <IonLabel className="text-center ion-text-wrap">
                <h2>Woohoo! You've joined the {venueDetail?.name} loyalty program.</h2>
              </IonLabel>

              {venueDetail?.hasSignUpBonus &&
                <IonLabel className="text-center ion-text-wrap mt">
                  <p>Your $2.00 off today sign up bonus has been automatically applied to your tab.</p>
                </IonLabel>}
            </div>
          </IonItem>

          {
            (!user.birthday || user.birthday.length !== 10) ? (
              <Formik
                initialValues={{
                  ...pick(user, ['birthday']),
                  birthday: !user.birthday ? '' : moment(user.birthday).format('MM/DD/YYYY'),
                }}
                onSubmit={handleSubmit}
                validationSchema={schema}
              >
                {({ isSubmitting }) => {
                  return (
                    <Form>
                      <IonLoading isOpen={isSubmitting} message="Loading..." />
                      <IonList>

                        <IonItem lines="none" className="mb-2x">
                          <IonLabel className="text-center ion-text-wrap">
                            <h2>Get extra perks on your special day</h2>
                          </IonLabel>
                        </IonItem>

                        <Field
                          component={InputField}
                          name="birthday"
                          label="Birthday"
                          placeholder="MM/DD/YYYY"
                          displayFormat="MM/DD/YYYY"
                        />

                        <IonItem lines="none" className="mt-5x">
                          <div className="d-flex-content d-flex-center">
                            <IonButton
                              color="secondary"
                              expand="block"
                              fill="solid"
                              type="submit"
                              disabled={isSubmitting}
                              className="loyalty-button-wrap"
                            >
                              Submit
                            </IonButton>

                          </div>
                        </IonItem>

                        <IonItem lines="none">
                          <div className="d-flex-content d-flex-center">
                            <IonButton
                              color="medium"
                              expand="block"
                              fill="solid"
                              type="button"
                              onClick={onCloseAction}
                              className="loyalty-button-wrap"
                            >
                              SKIP
                            </IonButton>

                          </div>
                        </IonItem>

                      </IonList>
                    </Form>
                  );
                }}
              </Formik>
            ) : (
              <IonItem lines="none" className="mt-5x">
                <div className="d-flex-content d-flex-center">
                  <IonButton
                    color="secondary"
                    expand="block"
                    fill="solid"
                    type="button"
                    onClick={onCloseAction}
                    className="loyalty-button-wrap"
                  >
                    GOT IT
                  </IonButton>

                </div>
              </IonItem>
            )
          }
        </IonList>
      </IonContent>
    </IonModal>
  );
}

LoyaltyJoinConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  setLoyaltyTypeModal: PropTypes.func,
  venueDetail: PropTypes.object,
  refreshAction: PropTypes.func,
  locationId: PropTypes.string,
};

export default LoyaltyJoinConfirmModal;
